/* YF-CC (Claude, Oct 2026): places the hero review badge, the review section, and the cost / airline page blocks.
   All markup is rendered by Liquid in snippets/yf-cc-*.liquid; this file only positions it and wires the taps.
   Notes: snippets/yf-cc-notes.liquid */
(function () {
  var Y = window.YFCC || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function after(ref, el) { ref.parentNode.insertBefore(el, ref.nextSibling); }
  function press(group, btn) { group.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); }); }
  var main = $('#MainContent') || $('main') || document.body;
  // a few short class names in the yf-cc snippets are also used by the theme (.yfla .pk, .flag, .hrs, .ladder, .mini,
  // .head); rename them before the sections are shown so the theme's rules never reach them
  var RN = { pk: 'yc-pick', flag: 'yc-flag', hrs: 'yc-hrs', ladder: 'yc-ladder', mini: 'yc-minis', head: 'yc-head' };
  $$('#yfcc-reviews, #yfcc-courses, #yfcc-fleet, #yfcc-airlines').forEach(function (sec) {
    Object.keys(RN).forEach(function (k) { $$('.' + k, sec).forEach(function (el) { el.classList.remove(k); el.classList.add(RN[k]); }); });
  });

  function firstH1() {
    var hs = $$('h1', main);
    for (var i = 0; i < hs.length; i++) { if (hs[i].offsetParent !== null || hs[i].getClientRects().length) return hs[i]; }
    return hs[0] || null;
  }
  function lum(c) {
    var m = (c || '').match(/\d+(\.\d+)?/g); if (!m) return 0;
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
  }

  /* ---------- 1. hero review badge ---------- */
  function badge() {
    var h1 = firstH1(); if (!h1 || !Y.av || !Y.av.length || $('.yfcc-rvb')) return;
    var light = lum(getComputedStyle(h1).color) > 0.6;
    var imgs = Y.av.map(function (u) { return '<img src="' + u + '" alt="" width="40" height="40" decoding="async">'; }).join('');
    var wrap = document.createElement('div');
    var ta = getComputedStyle(h1).textAlign;
    wrap.className = 'yfcc yfcc-rvbwrap' + (ta === 'center' ? ' c' : '');
    wrap.innerHTML = '<a class="yfcc-rvb' + (light ? '' : ' lt') + '" href="#yfcc-reviews" aria-label="Rated 5.0 out of 5 from ' + Y.count + ' Google reviews"><span class="av" aria-hidden="true"><span class="tr">' + imgs + imgs + '</span></span><span class="tx"><span class="top">5.0 <span class="st">★★★★★</span></span><span class="bt">' + Y.count + ' Google reviews</span></span></a>';
    // put it above any kicker line that sits right above the h1
    var anchor = h1, prev = h1.previousElementSibling;
    if (prev && prev.textContent.trim().length < 90 && !prev.querySelector('h1,img,a.btn,.btn')) anchor = prev;
    anchor.parentNode.insertBefore(wrap, anchor);
    // reviews never show twice: hide small rating chips already in the hero
    var hero = h1.closest('header,section,[class*="hero"]') || h1.parentNode;
    $$('*', hero).forEach(function (el) {
      if (el === wrap || wrap.contains(el) || el.contains(h1) || el.querySelector('h1')) return;
      var t = (el.textContent || '').trim();
      if (t.length > 0 && t.length < 80 && el.children.length <= 4 && /★|google review|\d+\+?\s*(google\s*)?reviews|\b5\.0\b/i.test(t)) {
        var p = el.parentElement;
        // hide the whole chip if its parent is just the chip
        if (p && p !== hero && !p.contains(h1) && (p.textContent || '').trim().length < 90) el = p;
        el.classList.add('yfcc-hide');
      }
    });
    wrap.querySelector('a').addEventListener('click', function (e) {
      var r = $('#yfcc-reviews:not([hidden])') || findReviewHeading();
      if (r) { e.preventDefault(); r.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    });
  }
  function findReviewHeading() {
    var hs = $$('h2', main).filter(function (h) { return !h.closest('#yfcc-reviews') && /what our flyers say|loved on google/i.test(h.textContent); });
    return hs[0] ? (hs[0].closest('section') || hs[0]) : null;
  }

  /* ---------- 2. review section ---------- */
  function reviews() {
    var sec = $('#yfcc-reviews'); if (!sec) return;
    if (findReviewHeading()) { sec.parentNode.removeChild(sec); return; }  // page already has one
    var kids = $$(':scope > *', main).filter(function (k) { return k.offsetHeight > 0; });
    var last = kids[kids.length - 1];
    if (last && (last.textContent || '').trim().length < 1800 && last.querySelector('a')) main.insertBefore(sec, last);
    else main.appendChild(sec);
    sec.hidden = false;
    var row = $('.row', sec), chips = $$('.yc-chip', sec);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        press(chips, c); var f = c.getAttribute('data-f');
        $$('.card', row).forEach(function (r) { r.hidden = !(f === 'all' || (' ' + r.getAttribute('data-t') + ' ').indexOf(' ' + f + ' ') > -1); });
        row.scrollLeft = 0;
      });
    });
    $$('.nav button', sec).forEach(function (b) {
      b.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth * 0.9 * (+b.getAttribute('data-d')), behavior: reduce ? 'auto' : 'smooth' }); });
    });
    $$('.more', sec).forEach(function (m) {
      m.addEventListener('click', function () { var c = m.closest('.card'); c.classList.toggle('open'); m.textContent = c.classList.contains('open') ? 'Show less' : 'Read more'; });
    });
  }

  /* ---------- 3. cost page ---------- */
  function cost() {
    var cs = $('#yfcc-courses'); if (!cs) return;
    document.body.classList.add('yfcc-on-cost');
    var h1 = firstH1(), hero = h1 && (h1.closest('header,section') || h1.parentNode);
    if (hero) after(hero, cs); else main.insertBefore(cs, main.firstChild);
    cs.hidden = false;
    // the old rating tabs (dark bar that sticks while scrolling) are replaced by the course blocks above
    $$('.ppb-courses').forEach(function (o) { o.classList.add('yfcc-hide'); });
    var fl = $('#yfcc-fleet');
    if (fl) { after(cs, fl); fl.hidden = false; }
    var bs = $$('.cb', cs);
    bs.forEach(function (b) {
      b.addEventListener('click', function () {
        press(bs, b);
        bs.forEach(function (x) { $('.yc-pick', x).textContent = x === b ? '✓ Selected' : 'See packages'; });
        var k = b.getAttribute('data-c');
        $$('.dt', cs).forEach(function (d) { d.hidden = d.id !== 'yfcc-c-' + k; });
        var d = $('#yfcc-c-' + k);
        if (d) d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- 4. airline page ---------- */
  function airline() {
    var s = $('#yfcc-airlines'); if (!s) return;
    var h2 = $$('h2', main).filter(function (h) { return /what the career pays/i.test(h.textContent); })[0];
    var host = h2 && (h2.closest('section') || h2.parentNode);
    if (!host) { var h1 = firstH1(); host = h1 && (h1.closest('header,section') || h1.parentNode); }
    if (host) after(host, s); else main.appendChild(s);
    s.hidden = false;
    // logos are printed once; copy them for the endless rows, the category grids and the ladder steps
    var tiles = {};
    $$('.ltr .lg', s).forEach(function (t) { tiles[t.getAttribute('data-k')] = t; });
    $$('.ltr', s).forEach(function (row) {
      $$('.lg', row).forEach(function (t) { var c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true'); row.appendChild(c); });
    });
    $$('[data-l]', s).forEach(function (box) {
      box.getAttribute('data-l').split(',').forEach(function (k) { if (tiles[k]) box.appendChild(tiles[k].cloneNode(true)); });
    });
    var gb = $$('.yc-chip', s);
    gb.forEach(function (b) {
      b.addEventListener('click', function () {
        press(gb, b); var g = b.getAttribute('data-g');
        $$('[data-g]', s).forEach(function (el) { if (!el.classList.contains('yc-chip')) el.hidden = el.getAttribute('data-g') !== g; });
      });
    });
    var rb = $$('.rung', s);
    rb.forEach(function (b) {
      b.addEventListener('click', function () {
        press(rb, b); var r = b.getAttribute('data-r');
        $$('.rtx', s).forEach(function (t) { t.hidden = t.getAttribute('data-r') !== r; });
      });
    });
  }

  function run() {
    try { badge(); } catch (e) { console.warn('yfcc badge', e); }
    try { cost(); } catch (e) { console.warn('yfcc cost', e); }
    try { airline(); } catch (e) { console.warn('yfcc airline', e); }
    try { reviews(); } catch (e) { console.warn('yfcc reviews', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
